import { Link } from "react-router-dom";
import { VultLogo } from "../components/Logo";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA] px-4">
      <div data-testid="vult-payment-cancel-page" className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-[8px_8px_0_#0F172A]">
        <div className="flex justify-center"><VultLogo /></div>
        <div className="mt-8 flex flex-col items-center">
          <XCircle size={56} className="text-slate-400" />
          <h1 className="mt-4 font-display text-2xl font-black uppercase text-slate-900">Pagamento cancelado</h1>
          <p className="mt-2 text-sm text-slate-600">Nenhuma cobrança foi feita. Seu carrinho continua salvo na loja.</p>
        </div>
        <Link
          data-testid="vult-payment-cancel-back"
          to="/"
          className="mt-8 block w-full rounded-full bg-slate-900 py-3.5 font-mono text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-vult-red hover:text-slate-900"
        >
          Voltar à loja
        </Link>
      </div>
    </div>
  );
}
